import corpImage from '../images/species/Avatar_Corp.jpg'
import kaltoranImage from '../images/species/Avatar_Kaltoran.jpg'
import legionImage from '../images/species/Avatar_Legion.jpg'
import nephilimImage from '../images/species/Avatar_Nephilim.jpg'
import palantorImage from '../images/species/Avatar_Palantor.jpg'
import remnantImage from '../images/species/Avatar_Remnant.jpg'
import twifarImage from '../images/species/Avatar_Twi_Far.jpg'
import zhouImage from '../images/species/Avatar_Zhou.jpg'
import { Ability } from './character'

export interface SpeciesData {
    name: string,
    image: string,
    color: string,
    description: string,
    subcultures: string[];
    adjustments: { 
            targetId: string, 
            adjustment: number
    }[],
    strongHits: Ability[];
}

export type SpeciesDataList = { [k: string]: SpeciesData}

export const SpeciesList: SpeciesDataList = {
    corp: {
        name: "Corp",
        image: corpImage,
        color: "#fbab19",
        description: "+1 current Resource and Influence.\nLanguages: Corp and Corp Code (CC).\nComplication: Prejudice from Kaltorans.",
        subcultures: ["Neon Hunter", "Socialite", "Suit", "Vargartian", "(Other)"],
        adjustments: [
            {
            "adjustment": 1,
            "targetId": "wealth"
            },
            {
            "adjustment": 1,
            "targetId": "culture"
            },
            {
            "adjustment": 1,
            "targetId": "tactical"
            },
            {
            "adjustment": 2,
            "targetId": "influenceMax"
            },
            {
            "adjustment": 2,
            "targetId": "resourcesMax"
            },
            {
            "adjustment": -2,
            "targetId": "str_max"
            },
            {
            "adjustment": 1,
            "targetId": "operations"
            }
        ],
        strongHits: [],
    },
    kaltoran: {
        name: "Kaltoran",
        image: kaltoranImage,
        color: "#3c61b9",
        description: "Reduce all Untrained Skill Roll penalties by 1 (normally -2, Stacks).\nVisibility Cover -1, all Weapons.\nYou share genetic memories with your ancestors.\n» You may use Skills to perform Ancestral Memory Arcane Rolls (pg: 24).\nLanguages: Corp and Kaltoran.\nComplication: Unwanted Ancestral Memories.\nComplication: Prejudice from Corporation.",
        subcultures: ["Dark Tribe", "Pioneer", "Rascal", "Vagabond", "Watcher", "(Other)"],
        adjustments: [
        {
          "adjustment": 1,
          "targetId": "awareness"
        },
        {
          "adjustment": 1,
          "targetId": "stealth"
        },
        {
          "adjustment": 1,
          "targetId": "smallarms"
        },
        {
          "adjustment": 1,
          "targetId": "gritReroll"
        },
        {
          "adjustment": -2,
          "targetId": "foc_max"
        },
        {
          "adjustment": 1,
          "targetId": "engineering"
          }
        ],
        strongHits: [],
    },
    legion: {
        name: "Legion",
        image: legionImage,
        color: "#c7151e",
        description: "You may function in Space hostile environments for 5 minutes a day.\nYou may function in Arctic hostile environments.\nLanguages: Corp, Legion and Hand Signals.\nComplication: Inner Fire.",
        subcultures: ["Auxilia - Foreign","Auxilia - Interior", "Auxilia - Operations", "Auxilia - Prime", "Exilia", "Nomad", "(Other)"],
        adjustments: [
        {
          "adjustment": 1,
          "targetId": "leadership"
        },
        {
          "adjustment": 1,
          "targetId": "resolve"
        },
        {
          "adjustment": 1,
          "targetId": "heavyarms"
        },
        {
          "adjustment": 1,
          "targetId": "armor"
        },
        {
          "adjustment": -1,
          "targetId": "armorAtZero"
        },
        {
          "adjustment": -2,
          "targetId": "mob_max"
        },
        {
          "adjustment": 1,
          "targetId": "gunnery"
        }
      ],
      strongHits: [],
    },
    nephilim: {
        name: "Nephilim",
        image: nephilimImage,
        color: "#1cb44c",
        description: "Languages: Corp and Nephilim (Junk, Neph Code (NC) and dialect that matches your genus).\nComplication: Prejudice from Kaltorans and Legion.",
        subcultures: ["Emissary", "Gargantuan", "Lessercrat", "Risencrat", "Sentient Munition", "Tenebrous", "(Other)", ],
        adjustments: [
        {
          "adjustment": 1,
          "targetId": "biotech"
        },
        {
          "adjustment": 1,
          "targetId": "medicine"
        },
        {
          "adjustment": 1,
          "targetId": "exotic"
        },
        {
          "adjustment": 2,
          "targetId": "enduranceDamage"
        },
        {
          "adjustment": 2,
          "targetId": "acquisitionRolls"
        },
        {
          "adjustment": -2,
          "targetId": "culture"
        },
        {
          "adjustment": 1,
          "targetId": "command"
        }
      ],
      strongHits: [],
    },
    palantor: {
        name: "Palantor",
        image: palantorImage,
        color: "#b32589",
        description: "You may gain +1 different Utility (normally limited to 1).\nPerk: You’re a Palantor Robot (may rebuild your body with 18t and Workshop).\nLanguages: Corp, Palantor and Palantor Code (PC).",
        subcultures: ["MVP - Bear", "MVP - Butterfly", "MVP - Crane", "MVP - Fox", "MVP - Lion", "MVP - Monkey", "MVP - Rat", "MVP - Snake", "MVP - Squirrel", "MVP - Toad", "Puppeteer", "Spark - Blue", "Spark - Green", "Spark - Pink", "Spark - Purple", "Spark - Yellow", "(Other)", ],
        adjustments: [
        {
          "adjustment": 1,
          "targetId": "mechanics"
        },
        {
          "adjustment": 1,
          "targetId": "computers"
        },
        {
          "adjustment": 1,
          "targetId": "tactical"
        },
        {
          "adjustment": -2,
          "targetId": "ref_max"
        },
        {
          "adjustment": -1,
          "targetId": "biotech"
        },
        {
          "adjustment": -1,
          "targetId": "medicine"
        },
        {
          "adjustment": 1,
          "targetId": "operations"
        }
      ],
      strongHits: [
        {
          "id": "c2b3fc04-33e8-4263-bb80-7468a0ad9523",
          "name": "Weak vs Disruptor",
          "limitedUseMax": 1,
          "limits": "",
          "requirements": ["Disruptors hits you"],
          "results": "Disruptors deal 1 auto Strong Hit against you (Stacks).",
          "type": ""
        }
      ],
    },
    remnant: {
        name: "Remnant",
        image: remnantImage,
        color: "#1a162d",
        description: "Languages: Corp and Ursai.\nSuffering 2 Attribute damage from a single Attack; causes you to Bleed.\nComplication: Prejudice from Corporation and Legion.",
        subcultures: ["All-Faith", "All-Truth", "Psion Mind", "(Other)"],
        adjustments: [
        {
          "adjustment": 1,
          "targetId": "persuasion"
        },
        {
          "adjustment": 1,
          "targetId": "psychology"
        },
        {
          "adjustment": 1,
          "targetId": "smallarms"
        },
        {
          "adjustment": 2,
          "targetId": "maximumAttributePoints"
        },
        {
          "adjustment": 1,
          "targetId": "gunnery"
        }
      ],
      strongHits: [],
    },
    twifar: {
        name: "Twi-Far",
        image: twifarImage,
        color: "#f37521",
        description: "A Faren shares your body:\n» Faren-Blast: One of your Weapons gains the Innate and Energy Keywords.\n» You may use Skills to perform Faren Arcane Rolls (pg: 26).\nLanguages: Corp and Twilinger.\nComplication: Prejudice from Zhou.",
        subcultures: ["Dragon Symphony", "Efreeti Symphony", "Lampad Symphony", "Phoenix Symphony", "Salamander Symphony", "Seraphim Symphony", "(Other)"],
        adjustments: [
            {
            "adjustment": 1,
            "targetId": "electronics"
            },
            {
            "adjustment": 1,
            "targetId": "astronomy"
            },
            {
            "adjustment": 1,
            "targetId": "heavyarms"
            },
            {
            "adjustment": -2,
            "targetId": "grit_max"
            },
            {
              "adjustment": 1,
              "targetId": "command"
            },
            {
            "adjustment": 1,
            "targetId": "engineering"
            }
        ],
        strongHits: [
            {
            "id": "6cc14157-cd65-40d8-8376-4aaaa28a6894",
            "name": "Weak vs Disruptor",
            "limitedUseMax": 1,
            "limits": "",
            "requirements": ["Disruptor hits you"],
            "results": "Disruptors deal 1 auto Strong Hit against you (Stacks).",
            "type": ""
            },
            {
            "id": "50902822-40ac-4ee8-b936-5f5a8ad30640",
            "name": "Strong vs Energy",
            "limitedUseMax": 1,
            "limits": "",
            "requirements": [],
            "results": "+1 personal Armour vs Energy.",
            "type": ""
            },
            {
            "id": "f1c95aed-79dd-47b4-b927-20a177be4e71",
            "name": "Energy Spread",
            "limitedUseMax": 1,
            "limits": "",
            "requirements": ["Energy Attacks that damages you."],
            "results": "Energy Attacks that damage you gain: Splash +1 (Stacks) and deal x2 End Dmg against you if from an ally.",
            "type": ""
            }
        ],
    },
    zhou: {
        name: "Zhou",
        image: zhouImage,
        color: "#6e3a22",
        description: "Your body is Zhou goo and various materials you’ve eaten.\n» You may function in all non-heat and non-intense radiation based hostile environments.\n» Immune to all sicknesses, stims, (including Strong Hit effects) and can eat any organics.\n» You may use Skills to perform Zhou Body Morph Arcane Rolls (pg: 29).\nLanguages: Corp and Nephilim (Zhou).\nMax intelligence: Change to -4 if you’re Tiny, or +2 if you’re Big (gained via Perks and/ or Traits)).\nComplication: Obsession, you’re eternally hungry (reduced effect if you’re tiny, or increased effect if you’re big).\nComplication: Prejudice from Nephilim.",
        subcultures: ["Chrome", "Organic", "Wilder", "(Other)"],
        adjustments: [
            {
            "adjustment": 1,
            "targetId": "physical"
            },
            {
            "adjustment": 1,
            "targetId": "planets"
            },
            {
            "adjustment": 1,
            "targetId": "exotic"
            },
            {
            "adjustment": 1,
            "targetId": "defence"
            },
            {
            "adjustment": -2,
            "targetId": "int_max"
            },
            {
            "adjustment": -1,
            "targetId": "wealth"
            },
            {
            "adjustment": -1,
            "targetId": "culture"
            },
            {
            "adjustment": -1,
            "targetId": "computers"
            }
        ],
        strongHits: []
    },
}